import { HStack } from '@cad-arc';
import { UnitStatusSearchForm } from '@mark43/cad-api';
import { SearchableLocationFilterSummary } from '../search-windows/searchable-location-filter-summary';
import { EventRelatedInformationFiltersSummary } from './event-related-information-filters-summary';
import { OtherFiltersSummary } from './other-filters-summary';
import { UnitInformationFiltersSummary } from './unit-information-filters-summary';

export function UnitStatusSearchResultsAppliedFilters({ form }: { form: UnitStatusSearchForm }) {
    return (
        <HStack
            justifyContent="space-between"
            alignItems="flex-start"
            backgroundColor="surface.background"
            w="100%"
            padding="24px var(--arc-space-14)"
        >
            <UnitInformationFiltersSummary form={form} />
            <SearchableLocationFilterSummary
                title="Involved Location"
                location={form.locations[0]}
                polygonPoints={form.polygonPoints}
            />
            <EventRelatedInformationFiltersSummary form={form} />
            <OtherFiltersSummary form={form} />
        </HStack>
    );
}
